import { AdminRoles } from './masterdata';

// When featureCategoryIds is set on a navigation item, we'll only show the
// navigation item IF the feature comes down in the authorization call for
// the user. If the feature isn't present for the employee/site, we'll
// simply not show that navigation item as an option.
//
// roles behaves in a similar way to featureCategoryIds. If the user is in
// one of the mentioned roles, it will show that navigation item as an option.
//
// defaultRoute indicates which route in the drawer we should redirect
// to when that tab is clicked.
export default [
  {
    order: 0,
    anchor: null,
    title: 'Dashboard',
    drawer: null,
    route: 'dashboard',
  },
  {
    order: 1,
    featureCategoryIds: [3],
    anchor: null,
    title: 'Time',
    drawer: 'time',
    defaultRoute: 'timecard',
    route: 'time',
  },
  {
    order: 2,
    anchor: null,
    title: 'People',
    drawer: 'people',
    defaultRoute: 'employees-list',
    route: 'people',
  },
  {
    order: 3,
    featureCategoryIds: [],
    featureIds: [3, 4, 5],
    anchor: null,
    title: 'HR',
    drawer: 'hr',
    route: 'hr',
  },
  {
    order: 4,
    anchor: null,
    title: 'Admin',
    drawer: 'admin',
    defaultRoute: 'organization-setup',
    roles: AdminRoles,
    route: 'admin',
  },
];
